import React, { useRef } from 'react'
import { Button } from '@mantine/core'
import CanvasDraw from '../canvas-draw'

const Mark = function ({
  currentFile,
  isShowWatermark,
  src,
  updateImg,
  onCancle,
  index,
}) {
  // const [loading, setLoading] = useState(false)
  const pics = isShowWatermark ? currentFile.originWatermarkUrl : src
  const drawRef = useRef()
  const height1 = document.getElementById('markContainer')?.offsetHeight
  const width1 = document.getElementById('markContainer')?.offsetWidth
  const height2 = document.getElementById('markContainer2')?.offsetHeight
  const width2 = document.getElementById('markContainer2')?.offsetWidth

  const getFile = () => {
    return drawRef.current.getFile()
  }
  const onUploadImg = () => {
    // setLoading(true)
    updateImg(getFile(), currentFile, onCancle, index)
  }

  return (
    <>
      <CanvasDraw
        width={width1 || width2 || 400}
        height={height1 || height2 || 400}
        color="red"
        brushRadius={2}
        imgSrc={pics}
        type="square"
        ref={drawRef}
        fileName={currentFile.filename.split('.')[0]}
      />
      <div className="flex items-center gap-3 mt-3 justify-end">
        <Button type="primary" onClick={onUploadImg}>
          保存
        </Button>
        <Button stroke onClick={onCancle}>
          取消
        </Button>
      </div>
    </>
  )
}

export default Mark
